import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
// import NominationForm from '../components/NominationForm';
import SendIcon from '@mui/icons-material/Send';
import API_BASE_URL from '../config';
import disposableDomains from '../utils/disposableDomains';

function NominationForm() {

  useEffect(() => {
    document.title = "Nomination Form | Outstanding Workplaces";
  }, []);

  const location = useLocation();
  const navigate = useNavigate();
  const prefillCompany = location.state?.companyName || '';

  const [form, setForm] = useState({
    firstName: '', lastName: '', role: '', email: '', mobile: '',
    typeOfCompany: '', companyName: prefillCompany, hq: '', industry: '', employees: '',
    howDidYouKnow: '', consent: false
  });

  const [emailError, setEmailError] = useState("");

  // Email validation function using disposableDomains
  const validateEmail = (email) => {
    const parts = email.split("@");
    if (parts.length !== 2) return false;
    const domain = parts[1].toLowerCase();
    return !disposableDomains.includes(domain);
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === 'checkbox' ? checked : value
    }));

    // Real-time email validation
    if (name === "email") {
      if (!validateEmail(value)) {
        setEmailError("Please enter your work email address.");
      } else {
        setEmailError("");
      }
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    // Final check before submit
    if (!validateEmail(form.email)) {
      setEmailError("Please enter your work email address.");
      return;
    }
    try {
      const res = await fetch(`${API_BASE_URL}/api/nominations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (res.ok && data.success) {
        navigate('/thank-you');
      } else {
        alert('Submission failed: ' + (data.error || 'Unknown error'));
        console.error('Submission error:', data);
      }
    } catch (err) {
      alert('Network or server error. See console for details.');
      console.error('Network/server error:', err);
    }
  };

  return (
    <div className="nomination-form-page" style={{  minHeight: "80vh", padding: "54px 0",marginTop: "-40px" }}>
      <div style={{ maxWidth: 750, margin: "0 auto", padding: "0 16px" }}>
        <h1 style={{
          textAlign: "center",
          fontSize: "3rem",
          fontWeight: 700,
          marginBottom: 40,
          letterSpacing: "-1px"
        }}>
          Get Start!
        </h1>
        {/* White background only for the form section */}
        <div style={{
          
          borderRadius: 16,
          boxShadow: "0 2px 8px #0001",
          padding: 25,
          margin: "0 auto",
          
          maxWidth: 660
        }}>
          <form className="nomination-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>* First Name</label>
                <input name="firstName" type="text" placeholder="Enter your first name" value={form.firstName} onChange={handleChange} required />
              </div>
              <div className="form-group" >
                <label>* Last Name</label>
                <input name="lastName" type="text" placeholder="Enter your last name" value={form.lastName} onChange={handleChange} required />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group" >
                <label>* Role</label>
                <select name="role" value={form.role} onChange={handleChange} required>
                  <option value="">-Select Role-</option>
                  <option>Founder / CEO</option>
                  <option>CHRO / Vice President</option>
                  <option>Head HR</option>
                  <option>HR / Training</option>
                  <option>Marketing Team</option>
                  <option>Talent Acquisition / Recruitment</option>
                  <option>Executive Team</option>
                  <option>Other</option>
                </select>
              </div>
              <div className="form-group" >
                <label>* Work Email Address</label>
                <input
                  name="email"
                  type="email"
                  placeholder="Enter your work email address"
                  value={form.email}
                  onChange={handleChange}
                  required
                  style={emailError ? { borderColor: "red" } : {}}
                />
                {emailError && (
                  <div >
                    {emailError}
                  </div>
                )}
              </div>
            </div>
            <div className="form-row">
              <div className="form-group" >
                <label>* Mobile Number</label>
                <input name="mobile" type="text" placeholder="Enter your mobile number" value={form.mobile} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>* Type of Company</label>
                <select name="typeOfCompany" value={form.typeOfCompany} onChange={handleChange} required>
                  <option value="">-Select-</option>
<option>Proprietorship</option>
<option>Partnership</option>
<option>Limited Liability Partnership (LLP)</option>
<option>Private Limited (Pvt Ltd)</option>
<option>Public Limited</option>
<option>One Person Company (OPC)</option>
<option>Corporation</option>
<option>Non-Governmental Organization (NGO)</option>
<option>Educational Institution / University</option>
<option>Others</option>                
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group" >
                <label>* Company Name</label>
                <input name="companyName" type="text" placeholder="Enter your Company Name" value={form.companyName} onChange={handleChange} required />
              </div>
              <div className="form-group" >
                <label>* Company's Headquarters</label>
                <select name="hq" value={form.hq} onChange={handleChange} required>
                  <option value="">-Select -</option>
                  <option>Andhra Pradesh</option>
                  <option>Arunachal Pradesh</option>
                  <option>Assam</option>
                  <option>Bihar</option>
                  <option>Chhattisgarh</option>
                  <option>Goa</option>
                  <option>Gujarat</option>
                  <option>Haryana</option>
                  <option>Himachal Pradesh</option>
                  <option>Jharkhand</option>
                  <option>Karnataka</option>
                  <option>Kerala</option>
                  <option>Madhya Pradesh</option>
                  <option>Maharashtra</option>
                  <option>Manipur</option>
                  <option>Meghalaya</option>
                  <option>Mizoram</option>
                  <option>Nagaland</option>
                  <option>Odisha</option>
                  <option>Punjab</option>
                  <option>Rajasthan</option>
                  <option>Sikkim</option>
                  <option>Tamil Nadu</option>
                  <option>Telangana</option>
                  <option>Tripura</option>
                  <option>Uttar Pradesh</option>
                  <option>Uttarakhand</option>
                  <option>West Bengal</option>
                  <option>Andaman & Nicobar Islands</option>
                  <option>Chandigarh</option>
                  <option>Dadra & Nagar Haveli and Daman & Diu</option>
                  <option>Delhi</option>
                  <option>Lakshadweep</option>
                  <option>Puducherry</option>
                  <option>Ladakh</option>
                  <option>Jammu & Kashmir</option>
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group" >
                <label>* Industry</label>
                <select name="industry" value={form.industry} onChange={handleChange} required>
                  <option value="">-Select Industry-</option>
                  <option>Agriculture</option>
                  <option>Automotive</option>
                  <option>Banking & Financial Services (BFSI)</option>
                  <option>Chemicals & Petrochemicals</option>
                  <option>Construction & Infrastructure</option>
                  <option>Consumer Goods & FMCG</option>
                  <option>Education & Training</option>
                  <option>Energy & Utilities</option>
                  <option>Engineering & Industrial Manufacturing</option>
                  <option>Environmental Services</option>
                  <option>Food & Beverage</option>
                  <option>Government & Public Sector</option>
                  <option>Healthcare & Pharmaceuticals</option>
                  <option>Hospitality & Tourism</option>
                  <option>Information Technology (IT) & Software</option>
                  <option>Insurance</option>
                  <option>Logistics & Supply Chain</option>
                  <option>Media & Entertainment</option>
                  <option>Mining & Metals</option>
                  <option>Manufacturing & Production</option>
                  <option>Non-Profit & NGOs</option>
                  <option>Oil & Gas</option>
                  <option>Real Estate</option>
                  <option>Retail & E-commerce</option>
                  <option>Telecommunications</option>
                  <option>Textiles & Apparel</option>
                  <option>Transportation</option>
                  <option>Research & Development (R&D)</option>
                  <option>Aerospace & Defense</option>
                  <option>Consulting & Professional Services</option>
                     <option>Others</option>
                </select>
              </div>
              <div className="form-group" >
                <label>* Number of Employees</label>
                <select name="employees" value={form.employees} onChange={handleChange} required>
                  <option value="">-Select-</option>
                  <option>10 - 20</option>
                  <option>21 - 50</option>
                  <option>51 - 100</option>
                  <option>101 - 200</option>
                  <option>501 - 1000</option>
                  <option>1001 - 3000</option>
                  <option>3001 - 5000</option>
                  <option>5001 - 10000</option>
                  <option>Above 10000</option>
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group" style={{ flex: 1, marginBottom: 10 }}>
                <label>* How did you come to know about us?</label>
                <select name="howDidYouKnow" value={form.howDidYouKnow} onChange={handleChange} required>
                  <option value="">-Select-</option>
                  <option>Google Search</option>
                  <option>Social Media</option>
                  <option>WhatsApp Group</option>
                  <option>HR Community</option>
                  <option>Referred by Others</option>
                </select>
              </div>
            </div>
           <div className="consent-checkbox">
           <label style={{ display: "block", transform: "translateY(-17px)" }}>
  <input
    name="consent"
    type="checkbox"
    checked={form.consent}
    onChange={handleChange}
    required
  />
  You acknowledge that you've read and understood the{" "}
  <a href="/terms-and-conditions" rel="noopener noreferrer">
    Terms and conditions
  </a>{" "}
  and{" "}
  <a href="/privacy-policy" rel="noopener noreferrer">
    Privacy policy
  </a>
  .*
</label>
          </div>
            <div style={{ marginTop: -6, textAlign: "left", fontSize: "16px", color: "#222" }}>
              <b>Note:</b> Apply separately for each legal entity to ensure accurate processing and proper record-keeping.
            </div>
           <Button 
  type="submit" 
  variant="contained"
  sx={{ 
    fontWeight: 600, 
    fontSize: '1.1rem', 
    borderRadius: '8px', 
    boxShadow: 'none', 
    textTransform: 'none', 
    padding: '10px 28px', 
    backgroundColor: '#0b1d51',

    '&:hover': { 
      backgroundColor: '#0b1d51', 
    } 
  }} 
> 
  SUBMIT 
</Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default NominationForm;